export default "__VITE_ASSET__6v7Ey5Jf__"